/**
 * Keyboard shortcut plumbing for the command centre.
 *
 * The frame mounts one listener (`KeyboardShortcuts`). Pages never listen for
 * raw keys themselves: a page that has a primary action subscribes to
 * `PRIMARY_ACTION_EVENT`, which the listener fires for `n`.
 */

export const PRIMARY_ACTION_EVENT = "drtutor:primary-action";
export const OPEN_SHORTCUTS_EVENT = "drtutor:shortcuts";

export function openShortcutSheet(): void {
  window.dispatchEvent(new CustomEvent(OPEN_SHORTCUTS_EVENT));
}

/** True while the user is typing, so single-key shortcuts stay out of the way. */
export function isTypingTarget(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el || !el.tagName) return false;
  const tag = el.tagName.toLowerCase();
  if (tag === "input" || tag === "textarea" || tag === "select") return true;
  if (el.isContentEditable) return true;
  return el.getAttribute("role") === "combobox" || el.getAttribute("role") === "textbox";
}

/** True while any modal dialog, drawer, palette or menu is open. */
export function isModalOpen(): boolean {
  return Boolean(document.querySelector('[aria-modal="true"], [role="menu"]'));
}

/** Subscribes a page's primary action to the `n` shortcut while mounted. */
export function onPrimaryAction(handler: () => void): () => void {
  const listener = () => handler();
  window.addEventListener(PRIMARY_ACTION_EVENT, listener);
  return () => window.removeEventListener(PRIMARY_ACTION_EVENT, listener);
}
